module.exports = __webpack_public_path__ + "static/media/suarez-esteban.4e0454d9.jpg";